import { styled } from '../../Utilities';
import { DocumentCardBase } from './DocumentCard.base';
import { getStyles } from './DocumentCard.styles';
export var DocumentCard = styled(DocumentCardBase, getStyles, undefined, {
  scope: 'DocumentCard'
});